module.exports = __webpack_public_path__ + "images/highFiveIllustration@2x.db9beced00641440d00a.png";